module.exports = __webpack_public_path__ + "images/hero-bg1-mobile.png";